import React from "react";
import PageHeading from "../../components/PageHeading";
import "./FleetManagement.css";

const FleetManagement = () => {
  return (
    <div className="fleet-management-page">
      <PageHeading title="Fleet Management" />
      <div className="coming-soon-container">
        <div className="coming-soon-text">
          <h2>Coming Soon</h2>
          <p>Fleet Management module will be available soon.</p>
        </div>
      </div>
    </div>
  );
};

export default FleetManagement;
